module.exports = __webpack_public_path__ + "img/trip(5).fbbdde28.webp";